export default __webpack_public_path__ + "static/media/circle_personangrepp.5aadcadd.png";